/**
 * Which session a page belongs to. The admin dashboard lives under `/admin`;
 * everything else is the public (customer) site.
 *
 * API requests pick their access token by area rather than by endpoint URL,
 * because admin pages also call admin-only endpoints outside `/admin/`
 * (for example `DELETE /files/{id}`).
 */
export type AuthArea = 'customer' | 'admin';

export function getAuthArea(pathname: string): AuthArea {
  return pathname === '/admin' || pathname.startsWith('/admin/') ? 'admin' : 'customer';
}

/** Login page for the given area. */
export function getLoginPath(area: AuthArea): string {
  return area === 'admin' ? '/admin/login' : '/login';
}
